export default __webpack_public_path__ + "static/media/BMMF-Phone01.9e7582ce.webp";